module.exports = __webpack_public_path__ + "img/silver1.627b6be6.png";